'use strict';

import React, { memo, useCallback } from 'react';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';

import ViewModeConstants from 'js/constants/ViewModeConstants';

import SettingsContainer from 'js/components/Settings/SettingsContainer';

import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';

import Tooltip from '@mui/material/Tooltip';
import { useLangFile } from 'js/context/LanguageContext';
import LanguageSelectorContainer from '../LanguageSelector/LanguageSelectorContainer';
import IconButton from '@mui/material/IconButton';
import { ArrowBack, HelpRounded } from '@mui/icons-material';
import Logo from 'js/components/UI-Elements/Logo';
import SeasonSelector from 'js/components/Seasons/SeasonSelector';
import Box from '@mui/material/Box';
import useBreakpoint from '../../hooks/useBreakpoint';
import viewModeConstants from 'js/constants/ViewModeConstants';

const styles = (theme) => ({
  root: {
    '& > *': {
      userSelect: 'none',
      pointerEvents: 'all',
    },
    pointerEvents: 'all',
    position: 'relative',
    zIndex: 11,
  },
});

const TopBar = ({
  classes,
  viewMode,
  changeFarm,
  goToPreviousViewMode,
  onChangeSeason,
  onAddNewSeason,
  onEditSeason,
  handleRestoreSeasonClick,
  goToOverviewViewMode,
}) => {
  const LangFile = useLangFile();

  const breakpoint = useBreakpoint();
  const narrow = breakpoint === 'sm' || breakpoint === 'xs';

  const openVideoPage = useCallback(() => {
    const url = `https://danishagro.dk/planteavl/cropline/support`;
    window.open(url, '_blank');
  }, []);

  return (
    <div className={classes.root}>
      <AppBar
        data-testid="dashboard-topbar"
        color={'inherit'}
        position="static"
        sx={{ backgroundColor: 'white' }}
      >
        <Toolbar variant="dense" disableGutters>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Box sx={{ width: '33.333%', display: 'flex', alignItems: 'center', pl: 2 }}>
              {(viewMode === ViewModeConstants.ANALYSIS ||
                viewMode === ViewModeConstants.ADD_EDIT_INNERBOUNDARIES ||
                viewMode === ViewModeConstants.EDIT_FIELD_BOUNDARIES ||
                viewMode === ViewModeConstants.SPLIT_FIELD ||
                viewMode === ViewModeConstants.MERGE_FIELDS ||
                viewMode === ViewModeConstants.BULK_PRESCRIPTION) && (
                <Tooltip title={LangFile.TopBar.goToPreviousViewMode}>
                  <IconButton color={'inherit'} onClick={goToPreviousViewMode}>
                    <ArrowBack />
                  </IconButton>
                </Tooltip>
              )}

              {viewMode === ViewModeConstants.EDIT_FIELD && (
                <Tooltip title={LangFile.TopBar.goToPreviousViewMode}>
                  <IconButton color={'inherit'} onClick={goToOverviewViewMode}>
                    <ArrowBack />
                  </IconButton>
                </Tooltip>
              )}

              {viewMode === ViewModeConstants.OVERVIEW && (
                <Box sx={{ pl: 1 }}>
                  <SeasonSelector
                    color={'white'}
                    handleRestoreSeasonClick={handleRestoreSeasonClick}
                    onChange={onChangeSeason}
                    onAddNew={onAddNewSeason}
                    onEdit={onEditSeason}
                  />
                </Box>
              )}
            </Box>

            <Box
              sx={{
                width: '33.333%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Logo variant={narrow ? 'short' : 'full'} size={24} />
            </Box>

            <Box
              sx={{
                width: '33.333%',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              <LanguageSelectorContainer size={'medium'} />

              <IconButton onClick={openVideoPage}>
                <HelpRounded color={'primary'} />
              </IconButton>

              <SettingsContainer changeFarm={changeFarm} LangFile={LangFile} />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
    </div>
  );
};

TopBar.propTypes = {
  viewMode: PropTypes.string,
  previousViewMode: PropTypes.string,
  goToPreviousViewMode: PropTypes.func,
  goToOverviewViewMode: PropTypes.func,
  handleRestoreSeasonClick: PropTypes.func,
};

export default memo(withStyles(styles)(TopBar));
